// extracted by mini-css-extract-plugin
export default {"menu":"menu_menu__IHaeI","option":"menu_option__ZSQUq","content":"menu_content__PQnHU","botao":"menu_botao__Skq2H","ativo":"menu_ativo__pj-vN"};